export function dateLogic(data, key, localizedStrings) {
  if (
    data.start_date_month !== "" &&
    data.start_date_year !== "" &&
    data.end_date_month !== "" &&
    data.end_date_year !== "" &&
    data.start_date_month !== null &&
    data.start_date_year !== null &&
    data.end_date_month !== null &&
    data.end_date_year !== null
  ) {
    const startDate = parseInt(
      data?.start_date_year + data?.start_date_month?.padStart(2, "0"),
      10,
    ); // Combine and ensure MM format
    const finishDate = parseInt(
      data?.end_date_year + data?.end_date_month?.padStart(2, "0"),
      10,
    ); // Combine and ensure MM format

    if (startDate > finishDate) {
      return localizedStrings.applicationpage.finishYearError;
    }
    if (
      (key === 5 || key === 6) &&
      data.usb_graduationdate &&
      data.usb_graduationdate !== ""
    ) {
      const graduationYear = parseInt(data?.usb_graduationdate, 10); // Extract year from graduation date (format: YYYY-MM-DD)
      const finishYear = parseInt(data?.end_date_year, 10);

      // Check if graduationYear is before finishYear
      if (graduationYear < finishYear) {
        // Only apply the additional condition for key === 6
        if (key === 6 && data.usb_currentdegreestatus !== 943240001) {
          return;
        }
        return localizedStrings.applicationpage.graduationYearError;
      }
    }

    // Clear error message if all validations pass
    return "";
  }
}
/**
 * Format a UTC date string extracting just the date portion
 * For dates like "2026-07-02T00:00:00Z", extract and return "2026/07/02"
 * @param {string} dateString - ISO date string (e.g., "2026-07-02T00:00:00Z")
 * @returns {string} - Formatted date in YYYY/MM/DD format
 */
export function formatDateInChicagoTimezone(dateString) {
  if (!dateString) return null;
  
  try {
    // Extract the date portion (YYYY-MM-DD) directly from the ISO string
    // This avoids timezone conversion issues since the date part should be displayed as-is
    const dateMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (dateMatch) {
      const year = dateMatch[1];
      const month = dateMatch[2];
      const day = dateMatch[3];
      return `${year}/${month}/${day}`;
    }
    return null;
  } catch (error) {
    console.error("Error formatting date:", error);
    return null;
  }
}